import { features } from "@/mocks/siteData";
import SectionHeading from "@/pages/home/components/SectionHeading";

const accents = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-800",
  "bg-secondary-100 text-secondary-800",
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
];

export default function Features() {
  return (
    <section id="features" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="为什么选择包子漫画"
          title="从找漫画到读完一话，尽量不让人分心"
          desc="平台围绕“看得顺、找得到、追得稳”来搭功能：作品够多、画质可选、进度能同步、入口有保障，具体体验在下面的六件事里说清楚。"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((item, i) => (
            <article
              key={item.title}
              className="reveal flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-200"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-lg ${accents[i % accents.length]}`}
              >
                <i className={`${item.icon} text-2xl`} aria-hidden="true" />
              </span>
              <h3 className="mt-5 font-heading text-lg text-foreground-950">{item.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}